import { useMemo } from 'react';
import { TabItem } from '../../components/components.interfaces';
import StaffList from './subviews/staffList/staffList';
import StaffAttendance from './subviews/attendance/staffAttendance';
import { StaffAttendanceProvider } from './contexts/staffAttendance.context';
import { StaffPayoutProvider } from './contexts/staffPayout.context';
import StaffPayout from './subviews/payouts/staffPayout';
import StaffEventsView from './subviews/staffEvents/staffEvents.view';
import { StaffEventsProvider } from './contexts/staffEvents.context';
import StaffDocumentsView from './subviews/staffDocuments/staffDocuments.view';
import { StaffDocumentsProvider } from './contexts/staffDocuments.context';
import { useRbacState } from 'src/context/rbac.context';
import { hasReadPermission } from 'src/utils/rbacHelpers';

type TranslateFunction = (key: string) => string;

export const staffSubRouteIds = [
  'staff-list',
  'attendance',
  'payouts',
  'events',
  'documents',
  'calendar',
];

export const useStaffTabMenuItems = (
  translateText: TranslateFunction
): TabItem[] => {
  const { rbac } = useRbacState();

  return useMemo(() => {
    const tabs: TabItem[] = [];

    if (hasReadPermission(rbac, 'staff', 'staffList')) {
      tabs.push({
        label: translateText('staff.tabs.staff'),
        onClickHandler: (val) => {
          // do nothing
        },
        tabPanel: <StaffList />,
      });
    }

    if (hasReadPermission(rbac, 'staff', 'attendance')) {
      tabs.push({
        label: translateText('staff.tabs.attendance'),
        onClickHandler: (val) => {
          // do nothing
        },
        tabPanel: (
          <StaffAttendanceProvider>
            <StaffAttendance />
          </StaffAttendanceProvider>
        ),
      });
    }

    if (hasReadPermission(rbac, 'staff', 'payouts')) {
      tabs.push({
        label: translateText('staff.tabs.payouts'),
        onClickHandler: (val) => {
          // do nothing
        },
        tabPanel: (
          <StaffPayoutProvider>
            <StaffPayout />
          </StaffPayoutProvider>
        ),
      });
    }

    if (hasReadPermission(rbac, 'staff', 'events')) {
      tabs.push({
        label: translateText('staff.tabs.events'),
        onClickHandler: (val) => {
          // do nothing
        },
        tabPanel: (
          <StaffEventsProvider>
            <StaffEventsView />
          </StaffEventsProvider>
        ),
      });
    }

    if (hasReadPermission(rbac, 'staff', 'documents')) {
      tabs.push({
        label: translateText('staff.tabs.documents'),
        onClickHandler: (val) => {
          // do nothing
        },
        tabPanel: (
          <StaffDocumentsProvider>
            <StaffDocumentsView />
          </StaffDocumentsProvider>
        ),
      });
    }

    return tabs;
  }, [rbac, translateText]);
};

export const getStaffTabIndex = (pathname: string) => {
  const staffTabsIndexObject = {
    staffList: 0,
    attendance: 1,
    payouts: 2,
    events: 3,
    documents: 4,
    calendar: 5,
  };

  const tabIndex =
    staffTabsIndexObject[pathname as keyof typeof staffTabsIndexObject];
  return tabIndex;
};

export const getStaffSubRouteId = (index: number) => staffSubRouteIds[index];
